const insuranceRelationships = [
	{ value: 'SELF', label: 'Self' },
	{ value: 'SPOUSE', label: 'Spouse' },
	{ value: 'SIGNIFICANT_OTHER', label: 'Significant other' },
	{ value: 'PARENT', label: 'Parent' },
	{ value: 'GRANDPARENT', label: 'Grandparent' },
	{ value: 'GUARDIAN', label: 'Guardian' },
	{ value: 'FOSTER_PARENT', label: 'Foster parent' },
	{ value: 'STEP_PARENT', label: 'Step parent' },
	{ value: 'UNCLE_OR_AUNT', label: 'Uncle or aunt' },
	{ value: 'CHILD', label: 'Child' },
	{ value: 'OTHER', label: 'Other' },
];

export default insuranceRelationships;
